import * as React from 'react';
import { SelectInput as SelectInputBase } from '@blend/consumer-components';

import * as inputUtils from '../inputUtils';
import InputContainer from '../InputContainer/InputContainer';

class SelectInput extends React.Component<InputProps, {}> {
  private inputWrapperRef = React.createRef<HTMLDivElement>();

  render() {
    const { input, choices, meta, disabled, label } = this.props;
    const name = input.name;
    const identifier = 'Select Input';
    const error = meta.touched && meta.error;
    const ariaProps = inputUtils.getAriaProps(name, !!error);

    return (
      <InputContainer error={error} active={meta.active} name={name} label={label} identifier={identifier}>
        <div ref={this.inputWrapperRef} className="SelectInput-inputWrapper">
          <SelectInputBase
            hasError={error}
            disabled={disabled}
            name={name}
            choices={choices}
            {...input}
            {...ariaProps}
          />
        </div>
      </InputContainer>
    );
  }
}

export const SelectInputConfig = {
  component: SelectInput,
};

export default SelectInput;
